require('./bootstrap');

import Alpine from 'alpinejs'
import { encode as blurhashEncode, decode as blurhashDecode } from 'blurhash'

window.Alpine = Alpine

Alpine.start()

window.blurhashEncode = blurhashEncode;
window.blurhashDecode = blurhashDecode;

// Encode a blurhash from a canvas element (uses a small downsampled canvas for speed)
window.encodeBlurhashFromCanvas = function (sourceCanvas, sampleSize = 32) {
    try {
        const ratio = sourceCanvas.width / sourceCanvas.height;
        let w = sampleSize;
        let h = sampleSize;
        if (ratio > 1) {
            h = Math.max(8, Math.round(sampleSize / ratio));
        } else if (ratio < 1) {
            w = Math.max(8, Math.round(sampleSize * ratio));
        }

        const small = document.createElement('canvas');
        small.width = w;
        small.height = h;
        const ctx = small.getContext('2d');
        ctx.drawImage(sourceCanvas, 0, 0, w, h);
        const imageData = ctx.getImageData(0, 0, w, h);
        return blurhashEncode(imageData.data, w, h, 4, 3);
    } catch (e) {
        console.warn('Blurhash encode failed:', e);
        return null;
    }
};

// Render a blurhash into the background of an element (as background-image data URL)
window.renderBlurhashBg = function (el, hash, size = 32) {
    if (!el || !hash) return;
    try {
        const pixels = blurhashDecode(hash, size, size);
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        const imageData = ctx.createImageData(size, size);
        imageData.data.set(pixels);
        ctx.putImageData(imageData, 0, 0);
        el.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`;
        el.style.backgroundSize = 'cover';
        el.style.backgroundPosition = 'center';
    } catch (e) {
        console.warn('Blurhash decode failed:', e);
    }
};

// Function to enable tooltips
function enableTooltip() {
    document.querySelectorAll('[data-tooltip]').forEach((element) => {
        // Ensure the tooltip is not added multiple times
        if (!element.classList.contains('tooltip-enabled')) {
            const tooltipText = element.getAttribute('data-tooltip');

            // Create the tooltip element
            const tooltip = document.createElement('div');
            tooltip.className = 'absolute bottom-full mb-2 hidden px-4 py-2 text-sm text-white bg-black rounded left-1/2 transform -translate-x-1/2';
            tooltip.textContent = tooltipText;

            // Create the arrow element under the tooltip
            const arrow = document.createElement('div');
            arrow.className = 'absolute left-1/2 transform -translate-x-1/2 bottom-[-4px] w-2.5 h-2.5 bg-black rotate-45';

            // Append the arrow to the tooltip
            tooltip.appendChild(arrow);

            // Append the tooltip to the element's parent
            element.parentElement.appendChild(tooltip);

            // Mark the element to prevent duplicate tooltips
            element.classList.add('tooltip-enabled');

            // Show the tooltip on hover
            element.addEventListener('mouseover', () => {
                tooltip.classList.remove('hidden');
            });

            // Hide the tooltip on mouseout
            element.addEventListener('mouseout', () => {
                tooltip.classList.add('hidden');
            });
        }
    });
}

// Make the function available in the global scope
window.enableTooltip = enableTooltip;




function toSnakeCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map((value) => toSnakeCase(value));
    } else if (obj && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            const snakeKey = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
            acc[snakeKey] = toSnakeCase(obj[key]);
            return acc;
        }, {});
    }
    return obj;
}

window.toSnakeCase = toSnakeCase;


function toCamelCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map((value) => toCamelCase(value));
    } else if (obj && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
            acc[camelKey] = toCamelCase(obj[key]);
            return acc;
        }, {});
    }
    return obj;
}

window.toCamelCase = toCamelCase;
